import { useFormContext } from 'react-hook-form';

import { useStepContext } from '~/app/providers/paymentStepProvider';
import { generateGradient } from '~/shared/lib/generateGradient';
import { Halo } from '~/shared/ui/Halo/Halo.ui';
import { Header } from '~/shared/ui/Header/Header';
import { IconImage } from '~/shared/ui/IconLogo/IconLogo.ui';

import { useLocalization } from '../../../../localization/localization';
import { FormType } from '../../../PayPage.scheme';
import { Logo } from '../../Logo/Logo';
import { CERTIFICATES_CONFIG } from '../SelectCertificateStep/constants/certificates';

import { Main, Root } from './PaymentStep.ui';
import { FormRu } from './components/FormRu/FormRu';
import { PaymentForm } from './components/PaymentForm';
import { ProductCard } from './components/ProductCard/ProductCard';

export const PaymentStep = ({
  appId,
  isLoading,
}: {
  appId?: string | null;
  isLoading: boolean;
}) => {
  const { goBack } = useStepContext();
  const { t } = useLocalization();
  const { getValues } = useFormContext<FormType>();

  const currentCertificate = getValues('certificate');
  const product = getValues('product');
  const { color, name, brand } = currentCertificate || {};

  const certificateData = CERTIFICATES_CONFIG[brand?.slug || ''];

  return (
    <Root>
      <Header onClick={goBack} title={t('Payment')} type="back" />
      <Halo
        aria-hidden="true"
        gradient={color && generateGradient(color)}
        top={300}
      />
      <Main>
        <ProductCard
          logo={
            certificateData?.logoUrl ? (
              <IconImage
                alt={name}
                loading="lazy"
                size={48}
                src={certificateData.logoUrl}
              />
            ) : (
              <Logo name={name || ''} />
            )
          }
          name={currentCertificate?.brand?.title || ''}
          amount={product?.info?.label || ''}
        />
        {appId === 'ru' ? <FormRu isLoading={isLoading} /> : <PaymentForm />}
      </Main>
    </Root>
  );
};
